import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Checkbox } from '@evertrue/et-components';
import { useEmailTemplatesProvider } from '../email-templates-context';

const EmailTemplatePreview = ({ className, shouldAddSubject, setShouldAddSubject }) => {
  const { selectedTemplate } = useEmailTemplatesProvider();
  const { templateBody = '' } = selectedTemplate || {};
  const parsedTemplateBody = useMemo(() => ReactHtmlParser(templateBody), [templateBody]);

  return (
    <div className={className || 'template-preview-container'}>
      <p className="section-title">Preview</p>

      <div className="subject-section">
        <span>Subject</span>
        <Checkbox
          label="Insert template subject"
          checked={shouldAddSubject}
          onChange={() => setShouldAddSubject(!shouldAddSubject)}
        >
          Insert template subject
        </Checkbox>
      </div>

      <p className="preview-subject">{selectedTemplate.templateSubject}</p>
      <p className="section-heading">Email Content</p>

      <div className="content-preview">
        {!!templateBody.length ? (
          <div className="parsed-template-content">{parsedTemplateBody}</div>
        ) : (
          <div className="empty-state">
            <p>Select a template to preview</p>
          </div>
        )}
      </div>
    </div>
  );
};

EmailTemplatePreview.propTypes = {
  className: PropTypes.string,
  shouldAddSubject: PropTypes.bool,
  setShouldAddSubject: PropTypes.func,
};

export default EmailTemplatePreview;
